import { environment } from './environments/default/environment';

export const CURRENT_PROJECT = environment.projectName;

export const IS_TRS_PROJECT = CURRENT_PROJECT === 'trs';

export const IS_PRODUCT_SAFETY_PROJECT = CURRENT_PROJECT === 'product-safety';
